import React from 'react';
import {
	Typography,
	Grid,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Box,
} from '@mui/material';

import ContainerBox from 'components/ContainerBox';
import { useTranslation } from 'services/localization/useTranslation';
import { stringEnum } from 'common/utils/objects';

interface Props {
	taxExcluded: boolean;
	onChange: (taxExcluded: boolean) => void;
}

const TaxType = stringEnum(['include', 'exclude']);

export const TaxRule = (props: Props) => {
	const { taxExcluded, onChange } = props;
	const { t } = useTranslation();

	return (
		<ContainerBox>
			<Grid container>
				<Grid item xs={12} sm={6}>
					<Typography variant="h5" gutterBottom>
						{t('shop.taxCalculation', 'Tax calculation')}
					</Typography>
					<Typography variant="body2" color="secondary" gutterBottom>
						{t('shop.taxCalculationInfo', 'Manage how your store calculates and shows taxes')}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormControl>
						<RadioGroup
							aria-label="taxCalculation"
							value={taxExcluded ? TaxType.exclude : TaxType.include}
							onChange={(e) => onChange(e.target.value === TaxType.exclude)}
						>
							<FormControlLabel
								value={TaxType.include}
								control={<Radio color="primary" />}
								label={
									<Box ml={1}>
										<Typography variant="body1">
											{t('shop.includeInPrice', 'Include tax in price')}
										</Typography>
										<Typography variant="body2" color="textSecondary">
											{t('shops.includeInPriceInfo', 'Product price includes tax')}.
										</Typography>
									</Box>
								}
							/>
							<Box mt={4} />
							<FormControlLabel
								value={TaxType.exclude}
								control={<Radio color="primary" />}
								label={
									<Box ml={1}>
										<Typography variant="body1">
											{t('shop.excludeFromPrice', 'Exclude tax from price')}
										</Typography>
										<Typography variant="body2" color="textSecondary">
											{t(
												'shops.excludedInPriceInfo',
												'Product price excludes tax. Tax will be added at checkout',
											)}
											.
										</Typography>
									</Box>
								}
							/>
						</RadioGroup>
					</FormControl>
				</Grid>
			</Grid>
		</ContainerBox>
	);
};
